var module;
// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/

var is_node = typeof module == 'object' && module.exports;
if (is_node) ;else ;
define(['i18next-http-backend', 'i18next-localstorage-backend', '/util/util.js', 'hola_opt', '/www/hola/pub/i18n_init.js', '/util/url.js'], (http_api, localstorage_backend, zutil, hopt, i18n_init, zurl) => {
  // XXX dmitriiz: webpack import fix
  if (localstorage_backend && localstorage_backend.default) localstorage_backend = localstorage_backend.default;
  if (http_api && http_api.default) http_api = http_api.default;
  return init_opt => {
    var backends = [localstorage_backend, http_api];
    var db_ver = zutil.get(hopt, 'www_hola.translation.db.defaultVersion', '');
    var backendOptions = [zutil.get(hopt, 'www_hola.translation.localstorage', {}), {
      loadPath: zutil.get(hopt, 'www_hola.translation.loadpath', '/www/hola/pub/locale/{{lng}}/{{ns}}.json') + (db_ver ? `?ver=${db_ver}` : '')
    }];
    var opt = zutil.get(hopt, 'www_hola.translation');
    var qs = zurl.qs_parse_url(location.href, {
      safe: true
    });
    backendOptions[0].defaultVersion = (init_opt && init_opt.ignore_zon ? '' : hopt.version) + backendOptions[0].defaultVersion + (qs.no_translation_cache == 'true' ? `${Math.random()}` : '');
    if (qs.version && opt.db) {
      backendOptions[0].expirationTime = (opt.db.max_age || 300) * 1000;
      backendOptions[1].queryStringParams = {
        version: qs.version
      };
      opt.ns = [...(opt.ns || []), qs.version];
    }
    return i18n_init(backends, backendOptions, opt, init_opt);
  };
});